import type { FaireProductEntity } from "../../entity_types/product";

export const p_kcpbzb5g59: FaireProductEntity = {
  token: "p_kcpbzb5g59",
  type: "product",
  name: "My Cat Is My Therapist Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c2485edd6254008fd3bf1cf70dcd55fc372ec31d1bc09064e63c2d9c5d0054d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f389e3c463d0802db82d63433001094e77a194e2187a3a0dca5b3447aa50b435.jpeg",
    "https://cdn.faire.com/fastly/8d2eceb7ece148ecd679ac35fa24a08454a834cedcee2c14422832886b9f3753.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/6426aca082406295afa7b46cf315a496944b5e82ae67c9af33b1ead54faf425c.jpeg",
    "https://cdn.faire.com/fastly/fc62bcbd46b7fff5f79ce2a1ac05025baae159f4e48125b3d3a94fa4c1e188bf.jpeg"
  ],
  priceDollars: 6.75,
  description: "Get these comfy gym socks that celebrate the REAL therapists in your life... Cats! You can talk to them for hours (or 50 minutes, depending on how they bill your insurance) about anything and everything! Talk all you want and they'll make the same nonplussed face at you... and just when you're not sure if you're having a breakthrough or a breakdown... they'll saunter up, rub their heads into your hands and whisper... ever so softy... \"we have to stop for today\".\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:55.511Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
